<template>
    <v-menu
            bottom
            :offset-y="true"
            transition="slide-y-transition"
    >
        <template v-slot:activator="{on,attrs}">
            <div class="file-count"
                 v-bind="attrs"
                 v-on="on">
                <img v-if="Object.keys(files).length > 0" src="@/assets/icons/table/files.svg" alt="">
                <img v-if="Object.keys(files).length === 0" src="@/assets/icons/table/no-files.svg" alt="">
                <div v-if="Object.keys(files).length > 0" class="file-count-notification">{{Object.keys(files).length}}</div>
            </div>
        </template>
        <v-list>
            <v-list-item
                    class="menu-item"
                    dense
                    v-for="file in files"
                    :key="'file_' + file.id"
            >
                <v-list-item-icon class="menu-item-icon menu-item-icon-file"/>
                <v-list-item-title>{{file.displayName}}<br /><span class="fileName">{{file.fileName}}</span></v-list-item-title>
                <v-list-item-icon class="menu-item-icon menu-item-icon-delete clickable" @click="removeFile(file.id)"/>
            </v-list-item>

            <v-dialog
                    v-model="dialog"
                    width="500"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-list-item
                            class="menu-item menu-item-upload"
                            :class="(files.length ? 'files-exist' : '')"
                            dense
                            v-bind="attrs"
                            v-on="on"
                    >
                        <v-list-item-icon class="menu-item-icon menu-item-icon-upload"/>
                        <v-list-item-title>{{$t('Upload file')}}</v-list-item-title>
                    </v-list-item>
                </template>

                <v-card>
                    <v-card-title class="headline grey lighten-2">{{$t('File Upload')}}</v-card-title>
                    <v-card-text>{{$t('Please select a file to add to this tag.')}}</v-card-text>
                    <v-card-text><v-file-input multiple truncate-length="50" v-model="file" /></v-card-text>
                    <v-divider />
                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                                color="primary"
                                text
                                @click="uploadFile"
                        >{{$t('Upload')}}</v-btn>
                        <v-btn
                                color="primary"
                                text
                                @click="dialog = false"
                        >{{$t('Cancel')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-list>
    </v-menu>
</template>

<script>
    import axios from "axios";
    import i18n from "../../i18n";

    export default {
        name: "Files",
        props: {
            files: Array
        },
        data: () => {
            return {
                dialog: false,
                file: null
            }
        },
        methods: {
            removeFile: function(fileId) {
                this.$emit('removeFile', fileId);
            },
            uploadFile: function() {
                let formData = new FormData();
                if (!Array.isArray(this.file)) {
                    this.file = [this.file];
                }
                for (let index in this.file) {
                    formData.append("file[]", this.file[index]);
                }

                axios.post('cedexTags/addFile', formData).then((function(response) {
                    if (response.data.success) {
                        this.$emit('addFile', response.data.files);
                        this.dialog = false;
                    } else {
                        this.$emit('showMessage', i18n.t('File upload failed'), 'error')
                    }
                }).bind(this)).catch((function() {
                    this.$emit('showMessage', i18n.t('File upload failed'), 'error')
                }).bind(this));

            }
        }
    }
</script>

<style scoped>

    div.file-count {
        text-align: center;
    }
    div.file-count img {
        width: 16px;
        height: 16px;
        display: inline-block;
    }
    div.file-count-notification {
        position: absolute;
        display: inline-block;
        text-align: center;
        padding: 2px 4px 0 4px;
        font-size: 10px;
        font-weight: bold;
        line-height: 11px;
        border-radius: 10px;
        background-color: #355b7f;
        color: white;
        border: 1px solid white;
        transform: translate(-8px, 7px);
    }

    span.fileName {
        color: var(--text-grey);
        font-size: 80%;
    }

    .menu-item-icon {
        margin-right: 8px !important;
        margin-left: 8px !important;
    }
    .menu-item-icon:first-child {
        margin-right: 16px !important;
    }
    .menu-item-icon:last-child {
        margin-left: 16px !important;
    }

    .menu-item-upload.files-exist {
        margin-top: 16px;
    }

    div.menu-item-icon-file {
        background-image: url("../../assets/icons/table/files.svg");
    }
    div.menu-item-icon-delete {
        background-image: url("../../assets/icons/table/bin.svg");
    }
    div.menu-item-icon-upload {
        background-image: url("../../assets/icons/table/upload.svg");
    }
</style>